import { stripExtension } from "@/assets/js/Utilities";

export default function prepareCustomLutForImport(file) {
    const reader = new FileReader();
    reader.readAsBinaryString(file)
    return new Promise((resolve, reject) => {
        reader.onload = async event => {
            const extension = file.name.split('.').pop();
            let lut = parseLut(reader.result);
            lut = await sanitizeLut(lut, extension).catch(errType => {
                return reject({
                    fileName: file.name,
                    errorType: errType
                })
            });

            if (!lut) return reject();
            // lut = resizeLut(lut);
            lut = composeNewLUT(lut);
            const blob = new Blob([lut], { type: 'text/plain' });
            blob.name = `${stripExtension(file.name)}.${extension}`;
            resolve(blob);
        };
    })
}

function parseLut(str) {
    if (typeof str !== 'string') {
        str = str.toString();
    }

    let title = null;
    let type = null;
    let size = 0;
    let domain = [[0.0, 0.0, 0.0], [1.0, 1.0, 1.0]];
    let data = [];
    let lines = str.split('\n');

    for (let i = 0; i < lines.length; i++) {
        let line = lines[i].trim();

        if (line[0] === '#' || line === '') {
            // Skip comments and empty lines
            continue;
        }

        let parts = line.split(/\s+/);

        switch (parts[0]) {
            case 'TITLE':
                title = line.slice(7, -1);
                break;
            case 'DOMAIN_MIN':
                domain[0] = parts.slice(1).map(Number);
                break;
            case 'DOMAIN_MAX':
                domain[1] = parts.slice(1).map(Number);
                break;
            case 'LUT_1D_SIZE':
                type = '1D';
                size = Number(parts[1]);
                break;
            case 'LUT_3D_SIZE':
                type = '3D';
                size = Number(parts[1]);
                break;
            default:

                data.push(parts[0]);
                data.push(parts[1]);
                data.push(parts[2]);
                data.push(1);
        }
    }

    return {
        title,
        type,
        size,
        domain,
        data: data.map(x => Number(x))
    };
}


export function resizeLut(lut) {
    var size = 21;

    var out = {
        data: new Array(size * size * size * 4),
        domain: lut.domain, // not used below
        size: size,
        title: null,
        type: '3D'
    };

    var dontOverflow = function (index) {
        if (index >= lut.data.length) {
            index = lut.data.length - 4;
        }
        return index;
    };

    for (var r = 0; r < size; r++) {
        var R = r / (size - 1), I, i = Math.floor(I = (lut.size - 1) * R);
        for (var g = 0; g < size; g++) {
            var G = g / (size - 1), J, j = Math.floor(J = (lut.size - 1) * G);
            for (var b = 0; b < size; b++) {
                var B = b / (size - 1), K, k = Math.floor(K = (lut.size - 1) * B);

                // indices

                var i0_j0_k0 = dontOverflow((((i + 0) * lut.size + (j + 0)) * lut.size + (k + 0)) * 4);
                var i0_j0_k1 = dontOverflow((((i + 0) * lut.size + (j + 0)) * lut.size + (k + 1)) * 4);
                var i0_j1_k0 = dontOverflow((((i + 0) * lut.size + (j + 1)) * lut.size + (k + 0)) * 4);
                var i0_j1_k1 = dontOverflow((((i + 0) * lut.size + (j + 1)) * lut.size + (k + 1)) * 4);
                var i1_j0_k0 = dontOverflow((((i + 1) * lut.size + (j + 0)) * lut.size + (k + 0)) * 4);
                var i1_j0_k1 = dontOverflow((((i + 1) * lut.size + (j + 0)) * lut.size + (k + 1)) * 4);
                var i1_j1_k0 = dontOverflow((((i + 1) * lut.size + (j + 1)) * lut.size + (k + 0)) * 4);
                var i1_j1_k1 = dontOverflow((((i + 1) * lut.size + (j + 1)) * lut.size + (k + 1)) * 4);

                var r_g_b = (((r * size) + g) * size + b) * 4;

                // interpolation ratios

                var ri = I - i, rj = J - j, rk = K - k;

                var r_i0_j0_k0 = (1 - ri) * (1 - rj) * (1 - rk);
                var r_i0_j0_k1 = (1 - ri) * (1 - rj) * rk;
                var r_i0_j1_k0 = (1 - ri) * rj * (1 - rk);
                var r_i0_j1_k1 = (1 - ri) * rj * rk;
                var r_i1_j0_k0 = ri * (1 - rj) * (1 - rk);
                var r_i1_j0_k1 = ri * (1 - rj) * rk;
                var r_i1_j1_k0 = ri * rj * (1 - rk);
                var r_i1_j1_k1 = ri * rj * rk;

                // interpolate all the channels

                for (var c = 0; c < 4; c++) {
                    out.data [r_g_b + c] =
                        r_i0_j0_k0 * lut.data [i0_j0_k0 + c] +
                        r_i0_j0_k1 * lut.data [i0_j0_k1 + c] +
                        r_i0_j1_k0 * lut.data [i0_j1_k0 + c] +
                        r_i0_j1_k1 * lut.data [i0_j1_k1 + c] +
                        r_i1_j0_k0 * lut.data [i1_j0_k0 + c] +
                        r_i1_j0_k1 * lut.data [i1_j0_k1 + c] +
                        r_i1_j1_k0 * lut.data [i1_j1_k0 + c] +
                        r_i1_j1_k1 * lut.data [i1_j1_k1 + c];
                }
            }
        }
    }
    return out;
}

function composeNewLUT(resizedLut) {
    var lutStr = '\nLUT_3D_SIZE ' + resizedLut.size + '\n\n';

    for (var i = 0; i < resizedLut.data.length; i++) {
        lutStr += (i % 4 == 3) ? '\n' : resizedLut.data[i].toFixed(6) + (
            (i % 4 < 2) ? ' ' : ''
        );
    }
    return lutStr.trim();
}

function sanitizeLut(lut, ext) {
    return new Promise(function (resolve, reject) {
        var validLength, validDataType, validExtensionType;

        validExtensionType = (ext.toLowerCase() == 'cube') ? true : false;
        validLength = checkLutLength(lut);
        validDataType = checkLutValues(lut);

        if (validLength === true && validDataType === true && validExtensionType === true) {
            resolve(lut);
        } else {
            if (validExtensionType !== true) {
                throw "incorrect file type"
            } else if (validDataType !== true || validLength !== true) {
                throw "incorrect LUT format"
            }
        }
    });
}

function checkLutLength(lut) {
    if ((lut.data.length) == (lut.size * lut.size * lut.size * 4)) return true;
    else return false;
}

function checkLutValues(lut) {
    let dataLength = lut.data.length;

    for (var i = 0; i < dataLength; i++) {
        if (isNaN(lut.data[i]) === true) return false
    }

    return true;
}
